module.exports = __webpack_public_path__ + "img/lv5.3826aaf2.png";